// extracted by mini-css-extract-plugin
export default {"root":"RecognitionPopup__root--2YTic"};